import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getTeacherAssignments, getTeacherClasses, getSchool, setAssignment, setClass, getTeacherStudents, getClassesSprints, setEvaluation, editEvaluationTeacher, setClassIndex, getEvaluations, setLoadingAssets } from '../../../../redux';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import GradeTile from '../GradeTile/New';
import Pagination from '../Pagination';
import '../index.css';

const statusMap = {
    'Missing Grade': '',
    'Reviews to Grade': 'StudentSubmitted',
    'Reviews to Regrade': 'StudentResubmitted'
}

function EditGrading (props) {
    const navigate = useNavigate();
    const [state, setState] = useState({
        classIndex: props.classIndex,
        isViewingClassMenu: false,
        sortMethod: "",
        status: "Missing Grade",
        message: '',
        pageSize: "10",
        page: "1",
        numOfPages: null,
        loading: true,
        evaluationsToHide: [],
    });

    useEffect(() => {
        props.getTeacherClasses(props.user._id);
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!props.teacherClasses || props.teacherClasses.length === 0) return;
        props.getEvaluations(
            {
                class: props.teacherClasses[state.classIndex]._id,
                status: statusMap[state.status] || undefined,
                teacherGrade: statusMap[state.status] === '' ? { $exists: 0 } : undefined,
            },
            state.page,
            state.pageSize,
            state.sortMethod || "none",
            props.user._id
        );
        setState(prev => ({ ...prev, loading: false }));
    }, [props.teacherClasses?.length]);

    const retrieveEvaluations = async ({ page, pageSize, status, sortMethod }) => {
        setState({ ...state, loading: true });
        props.setLoadingAssets('gradingEvaluations');
        
        const thisStatus = status || state.status;
        const thisSortMethod = sortMethod || state.sortMethod;
        
        setState({ ...state, page, pageSize });
        const s = statusMap[thisStatus]
        await props.getEvaluations(
            {
                class: props.teacherClasses[state.classIndex]._id,
                status: s || undefined,
                teacherGrade: s === '' ? { $exists: 0 } : undefined,
            },
            page,
            pageSize,
            thisSortMethod || "none",
            props.user._id
        );
        setState({ ...state, page, pageSize, loading: false, evaluationsToHide: [] });
    }

    const handleBack = () => {
        props.setClassIndex(state.classIndex);
        navigate("/teacher");
    }

    const getMappedClassOptions = () => {
        return props.teacherClasses !== undefined ? props.teacherClasses
            .map((classObject, index) => {
                return (
                    <MenuItem
                        key={classObject.name + 'ClassMenu'}
                        value={classObject.name}
                        primaryText={classObject.name}
                        id="class"
                    />
                );
            })
            : null;
    }

    const handleClassDropdownChange = (e) => {
        const classIndex = props.teacherClasses.findIndex(classObject => classObject.name.trim() === e.target.innerText.trim());
        const classId = props.teacherClasses[classIndex]._id;
        const page = "1";
        setState({
            ...state,
            classIndex,
            page,
            message: "",
            evaluationsToHide: [],
        });

        props.getEvaluations(
            {
                class: classId,
                status: statusMap[state.status] || undefined,
                teacherGrade: statusMap[state.status] === '' ? { $exists: 0 } : undefined,
            },
            page,
            state.pageSize,
            state.sortMethod || "none",
            props.user._id
        );
    }

    const toggleClassMenu = () => {
        setState({
            ...state,
            isViewingClassMenu: !state.isViewingClassMenu,
            message: "",
        });
    }

    const manageStudents = () => {
        props.setClassIndex(state.classIndex);
        navigate("/manage/students");
    }

    const manageClasses = () => {
        navigate("/manage/classes");
    }

    const getMappedEvaluations = (evaluations, assignments) => {
        let assignment;
        const sprint = props.sprint;
        return evaluations
            .filter(evaluation => !(state.evaluationsToHide || []).includes(evaluation._id))
            .map((evaluation) => {
                assignment = assignments.find(assignment => assignment._id === evaluation.assignment);
                return assignment && (
                    <div className="gradeContainer" key={evaluation._id + "newGradeContainer"}>
                        <GradeTile
                            key={evaluation._id + "newGradeTile"}
                            thisAssignment={assignment}
                            thisEvaluation={evaluation}
                            handleFullCredit={() => giveFullCredit(evaluation, sprint)}
                            handleGiveFeedback={giveFeedback}
                            thisSprint={sprint}
                        />
                    </div>
                );
            });
    }

    const giveFullCredit = (evaluation, sprint) => {
        if (evaluation.status === "StudentSubmitted") {
            evaluation.status = "TeacherSubmitted"
        } else if (evaluation.status === "StudentResubmitted") {
            evaluation.status = "TeacherGraded"
        }
        let pointsForEvaluator = sprint.pointsForDoingEvaluation;
        evaluation.pointsForEvaluator = pointsForEvaluator;
        evaluation.feedback = "Full Points";
        evaluation.teacherGrade = 3;
        props.editEvaluationTeacher(evaluation, props.teacherEvaluations);
        const splittedNameReviewing = evaluation.nameOfReviewingStudent.split(",");
        const splittedNameReviewed = evaluation.nameOfReviewedStudent.split(",");
        setState({
            ...state,
            message: `Your feedback for ${splittedNameReviewing[1]} ${splittedNameReviewing[0][0]}. reviewing ${splittedNameReviewed[1]} ${splittedNameReviewed[0][0]}. has been saved.`,
            evaluationsToHide: [...state.evaluationsToHide, evaluation._id],
        });
    }

    const giveFeedback = (evaluation, sprint, feedback, grade) => {
        if (evaluation.status === "StudentSubmitted") {
            evaluation.status = "TeacherSubmitted"
        } else if (evaluation.status === "StudentResubmitted") {
            evaluation.status = "TeacherGraded"
        }
        evaluation.pointsForEvaluator = sprint.pointsForDoingEvaluation * parseInt(grade, 10) / 3;
        evaluation.feedback = feedback;
        evaluation.teacherGrade = parseInt(grade, 10);
        props.editEvaluationTeacher(evaluation, props.teacherEvaluations);
        const splittedNameReviewing = evaluation.nameOfReviewingStudent.split(",");
        const splittedNameReviewed = evaluation.nameOfReviewedStudent.split(",");
        setState({
            ...state,
            message: `Your feedback for ${splittedNameReviewing[1]} ${splittedNameReviewing[0][0]}. reviewing ${splittedNameReviewed[1]} ${splittedNameReviewed[0][0]}. has been saved.`,
            evaluationsToHide: [...state.evaluationsToHide, evaluation._id],
        });
    }

    const handleDropdownChange = async (e) => {
        const sortMethod = e.target.innerText.trim()
        setState({ ...state, sortMethod })
        await retrieveEvaluations({ page: "1", pageSize: state.pageSize, sortMethod })
        setState({ ...state, sortMethod })
    }

    const handleFilterDropdownChange = async (e) => {
        const status = e.target.innerText.trim()
        setState({ ...state, status })
        await retrieveEvaluations({ page: "1", pageSize: state.pageSize, status })
        setState({ ...state, status })
    }

    const classObject = props.teacherClasses[state.classIndex] || { _id: "" };
    const classEvaluations = props.teacherEvaluations;
    const assignments = props.assignments;

    if (state.loading || props.loadingAssets.teacherClasses || props.loadingAssets.gradingEvaluations) {
      return (
          <div className="gradingPage">
              <div to="/teacher" className="backButton" onClick={handleBack} style={{ top: "-151px" }}>
                  <img src={require("../../../../Images/leftArrow.png")} alt="<-" />
                  Return to Dashboard
              </div>
              <div className="classElement" style={{ top: "-151px" }}>
                  <div className="classChoice">
                      <SelectField
                          name="class"
                          value={classObject.name}
                          onChange={handleClassDropdownChange}
                          iconStyle={{ paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px" }}
                          style={{ borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "200px" }}
                          labelStyle={{ color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px" }}
                          underlineStyle={{ border: "none" }}
                      >
                          {getMappedClassOptions()}
                      </SelectField>
                  </div>
                  {state.isViewingClassMenu &&
                      <div className="classMenuWindow">
                          <h4 onClick={manageClasses} style={{ fontWeight: 400, fontSize: "16px", marginTop: "5px", height: "40px", marginRight: "0px" }}>Manage Classes</h4>
                          <h4 onClick={manageStudents} style={{ fontWeight: 400, fontSize: "16px", marginTop: "5px", height: "40px", marginRight: "0px" }}>Manage Students</h4>
                      </div>
                  }
                  <div className="classMenu" onClick={toggleClassMenu}>
                      <i className="fa fa-ellipsis-v" style={{ textAlign: "center", fontSize: "16px", color: "rgba(0, 0, 0, 0.87)" }}></i>
                  </div>
              </div>
              <div className="classElement" style={{ top: "-103px" }}>
                  <h4>Sort by</h4>
                  <div className="classChoice">
                      <SelectField
                          name="sortMethod"
                          value={state.sortMethod}
                          hintText={"Select Sort Method"}
                          hintStyle={{ color: "black", position: "absolute", top: "5px" }}
                          onChange={handleDropdownChange}
                          iconStyle={{ paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px" }}
                          style={{ borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "200px" }}
                          labelStyle={{ color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px" }}
                          underlineStyle={{ border: "none" }}
                      >
                          <MenuItem
                              key={"Due Date"}
                              value={"Due Date"}
                              primaryText={"Due Date"}
                              id="sortMethod"
                          />
                          <MenuItem
                              key={"Review Length"}
                              value={"Review Length"}
                              primaryText={"Review Length"}
                              id="sortMethod"
                          />
                          <MenuItem
                              key={"Reviewed Student"}
                              value={"Reviewed Student"}
                              primaryText={"Reviewed Student"}
                              id="sortMethod"
                          />
                          <MenuItem
                              key={"Reviewing Student"}
                              value={"Reviewing Student"}
                              primaryText={"Reviewing Student"}
                              id="sortMethod"
                          />
                      </SelectField>
                  </div>
              </div>
              <div className="classElement" style={{ top: "-55px" }}>
                  <h4>Filter by</h4>
                  <div className="classChoice">
                      <SelectField
                          name="status"
                          value={state.status}
                          hintText={"Select Filter Method"}
                          hintStyle={{ color: "black", position: "absolute", top: "5px" }}
                          onChange={handleFilterDropdownChange}
                          iconStyle={{ paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px" }}
                          style={{ borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "200px" }}
                          labelStyle={{ color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px" }}
                          underlineStyle={{ border: "none" }}
                      >
                          <MenuItem
                              key={"Missing Grade"}
                              value={"Missing Grade"}
                              primaryText={"Missing Grade"}
                              id="status"
                          />
                          <MenuItem
                              key={"Reviews to Grade"}
                              value={"Reviews to Grade"}
                              primaryText={"Reviews to Grade"}
                              id="status"
                          />
                          <MenuItem
                              key={"Reviews to Regrade"}
                              value={"Reviews to Regrade"}
                              primaryText={"Reviews to Regrade"}
                              id="status"
                          />
                      </SelectField>
                  </div>
              </div>
              <div className="loading">
                  <img src={"/loading.svg"} alt="Loading..." />
              </div>
          </div>
      )
  }

  return (
      <div className="gradingPage">
          <div to="/teacher" className="backButton" onClick={handleBack} style={{ top: "-151px" }}>
              <img src={require("../../../../Images/leftArrow.png")} alt="<-" />
              Return to Dashboard
          </div>
          <div className="classElement" style={{ top: "-151px" }}>
              <div className="classChoice">
                  <SelectField
                      name="class"
                      value={classObject.name}
                      onChange={handleClassDropdownChange}
                      iconStyle={{ paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px" }}
                      style={{ borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "200px" }}
                      labelStyle={{ color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px" }}
                      underlineStyle={{ border: "none" }}
                  >
                      {getMappedClassOptions()}
                  </SelectField>
              </div>
              {state.isViewingClassMenu &&
                  <div className="classMenuWindow">
                      <h4 onClick={manageClasses} style={{ fontWeight: 400, fontSize: "16px", marginTop: "5px", height: "40px", marginRight: "0px" }}>Manage Classes</h4>
                      <h4 onClick={manageStudents} style={{ fontWeight: 400, fontSize: "16px", marginTop: "5px", height: "40px", marginRight: "0px" }}>Manage Students</h4>
                  </div>
              }
              <div className="classMenu" onClick={toggleClassMenu}>
                  <i className="fa fa-ellipsis-v" style={{ textAlign: "center", fontSize: "16px", color: "rgba(0, 0, 0, 0.87)" }}></i>
              </div>
          </div>
          <div className="classElement" style={{ top: "-103px" }}>
              <h4>Sort by</h4>
              <div className="classChoice">
                  <SelectField
                      name="sortMethod"
                      value={state.sortMethod}
                      hintText={"Select Sort Method"}
                      hintStyle={{ color: "black", position: "absolute", top: "5px" }}
                      onChange={handleDropdownChange}
                      iconStyle={{ paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px" }}
                      style={{ borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "200px" }}
                      labelStyle={{ color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px" }}
                      underlineStyle={{ border: "none" }}
                  >
                      <MenuItem
                          key={"Due Date"}
                          value={"Due Date"}
                          primaryText={"Due Date"}
                          id="sortMethod"
                      />
                      <MenuItem
                          key={"Review Length"}
                          value={"Review Length"}
                          primaryText={"Review Length"}
                          id="sortMethod"
                      />
                      <MenuItem
                          key={"Reviewed Student"}
                          value={"Reviewed Student"}
                          primaryText={"Reviewed Student"}
                          id="sortMethod"
                      />
                      <MenuItem
                          key={"Reviewing Student"}
                          value={"Reviewing Student"}
                          primaryText={"Reviewing Student"}
                          id="sortMethod"
                      />
                  </SelectField>
              </div>
          </div>
          <div className="classElement" style={{ top: "-55px" }}>
              <h4>Filter by</h4>
              <div className="classChoice">
                  <SelectField
                      name="status"
                      value={state.status}
                      hintText={"Select Filter Method"}
                      hintStyle={{ color: "black", position: "absolute", top: "5px" }}
                      onChange={handleFilterDropdownChange}
                      iconStyle={{ paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px" }}
                      style={{ borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "200px" }}
                      labelStyle={{ color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px" }}
                      underlineStyle={{ border: "none" }}
                  >
                      <MenuItem
                          key={"Missing Grade"}
                          value={"Missing Grade"}
                          primaryText={"Missing Grade"}
                          id="status"
                      />
                      <MenuItem
                          key={"Reviews to Grade"}
                          value={"Reviews to Grade"}
                          primaryText={"Reviews to Grade"}
                          id="status"
                      />
                      <MenuItem
                          key={"Reviews to Regrade"}
                          value={"Reviews to Regrade"}
                          primaryText={"Reviews to Regrade"}
                          id="status"
                      />
                  </SelectField>
              </div>
          </div>
          <h3>{state.status}</h3>
          <p>{state.message}</p>
          <div className="gradeTiles">
              {getMappedEvaluations(classEvaluations, assignments)}
          </div>
          <Pagination
              handleApiCall={retrieveEvaluations}
              page={state.page}
              pageSize={state.pageSize}
              numOfPages={props.numOfPages}
          />
      </div>
  );
}

export default connect(state => state.root, { getTeacherAssignments, getTeacherClasses, getSchool, setAssignment, setClass, getTeacherStudents, getClassesSprints, setEvaluation, editEvaluationTeacher, setClassIndex, getEvaluations, setLoadingAssets })(EditGrading);
